import axios from "axios";

export default {
    namespaced: true,

    state: {
        regionalWords: [],
        totalCount: 0,
        filteredResultsCount: 0,
        newestRegionalWord: {},
        newestRegionalWords: [],
        allRegionalWordsFilters: {
            sort: "id",
            search: null,
            sortOrder: "desc",
            user_id: null,
            letter: null,
            alphabetically: null,
            administrative_territory_id: null,
            offset: 0,
            limit: 50,
        },
        topActiveUsers: [],
        topAdministrativeTerritories: [],
    },

    getters: {
        regionalWords(state) {
            return state.regionalWords;
        },
        totalCount(state) {
            return state.totalCount;
        },
        newestRegionalWord(state) {
            return state.newestRegionalWord;
        },
        filteredResultsCount(state) {
            return state.filteredResultsCount;
        },
        newestRegionalWords(state) {
            return state.newestRegionalWords;
        },
        topActiveUsers(state) {
            return state.topActiveUsers;
        },
        topAdministrativeTerritories(state) {
            return state.topAdministrativeTerritories;
        },
    },

    mutations: {
        SET_REGIONAL_WORDS(state, list) {
            state.regionalWords = list;
        },
        SET_NEWEST_REGIONAL_WORD(state, newestRegionalWord) {
            state.newestRegionalWord = newestRegionalWord;
        },
        SET_TOTAL_COUNT(state, count) {
            state.totalCount = count;
        },
        SET_FILTERED_RESULTS_TOTAL_COUNT(state, count) {
            state.filteredResultsCount = count;
        },
        SET_NEWEST_REGIONAL_WORDS(state, regionalWords) {
            state.newestRegionalWords = regionalWords;
        },
        SET_FILTERS(state, value) {
            state.allRegionalWordsFilters = value;
        },
        SET_TOP_ACTIVE_USERS(state, value) {
            state.topActiveUsers = value;
        },
        SET_TOP_ADMINISTRATIVE_TERRITORIES(state, value) {
            state.topAdministrativeTerritories = value;
        },
    },

    actions: {
        async fetchAllRegionalWords({ commit, state }) {
            return await axios
                .get("/api/all-regional-words", {
                    params: state.allRegionalWordsFilters,
                })
                .then((response) => {
                    commit("SET_REGIONAL_WORDS", response.data.regional_words);
                    commit(
                        "SET_FILTERED_RESULTS_TOTAL_COUNT",
                        response.data.filterd_results_count
                    );
                    return response;
                });
        },
        async getNewestRegionalWords({ commit, state }) {
            await axios.get("/api/newest-regional-words").then((response) => {
                commit("SET_NEWEST_REGIONAL_WORDS", response.data);
            });
        },
        async getNewestRegionalWord({ commit }) {
            await axios.get("/api/newest-regional-word").then((response) => {
                commit("SET_NEWEST_REGIONAL_WORD", response.data);
            });
        },
        async getAllRegionalWordsCount({ commit }) {
            await axios
                .get("/api/get-all-regional-words-count")
                .then((response) => {
                    commit("SET_TOTAL_COUNT", response.data);
                });
        },
        async saveNewRegionalWord({ commit }, payload) {
            // const config = {
            //     headers: {
            //         "content-type": "multipart/form-data",
            //     },
            // };
            await axios
                .post("/api/create-regional-word", payload)
                .then((response) => {
                    // commit('SET_NEWEST_REGIONAL_WORD', response.data);
                });
        },
        async getRegionalWord({ commit }, id) {
            return await axios.get("/api/get-regional-word", {
                params: { id },
            });
        },
        async saveRegionalWordChanges({ commit }, payload) {
            await axios
                .post("/api/update-regional-word", payload)
                .then((response) => {});
        },
        async deleteRegionalWordFromDB({ commit }, id) {
            await axios
                .post("/api/delete-regional-word", { id })
                .then((response) => {});
        },
        async saveNewRegionalWordComment({ commit }, payload) {
            await axios
                .post("/api/create-regional-word-comment", payload)
                .then((response) => {
                    // commit('SET_NEWEST_REGIONAL_WORD', response.data);
                });
        },
        async getTopActiveUsers({ commit }, limit = 5) {
            await axios
                .get("/api/top-active-users", {
                    params: { limit },
                })
                .then((response) => {
                    commit("SET_TOP_ACTIVE_USERS", response.data);
                });
        },
        async getTopAdministrativeTerritories({ commit }, limit = 5) {
            await axios
                .get("/api/top-administrative-territories", {
                    params: { limit },
                })
                .then((response) => {
                    commit("SET_TOP_ADMINISTRATIVE_TERRITORIES", response.data);
                });
        },
        async updateData({ dispatch }) {
            await dispatch("getAllRegionalWordsCount");
            await dispatch("getNewestRegionalWord");
            await dispatch("fetchAllRegionalWords");
            await dispatch("getNewestRegionalWords");
            await dispatch("getTopActiveUsers");
            await dispatch("getTopAdministrativeTerritories");
        },
    },
};
